export const SecondarySites = {
  OUTLET: 'outlet',
};

export const SecondarySiteGroupRegex = '(?:/|\\?|$|-splash)';
